export default __webpack_public_path__ + "static/media/usa-flag.89987ae6.svg";